import { APIScope, LocationPageInterface, LocationScope } from "@swivl-mono/types";
import { useLocation } from "react-router-dom";

import { HasPermission } from "../Helpers/Permissions/CheckPermissions";
import LocationsModel from "../Models/Locations/Locations.Model";
import { Member } from "../Models/Member/Member.Current";

export function usePropertiesGetLocationIds(): LocationPageInterface {
  const { locations, groups } = LocationsModel.useState();
  const location = useLocation();
  const split = location.pathname.split("/");
  let output: LocationPageInterface = {
    path: location.pathname,
    type: LocationScope.ORG,
    typeTitle: "Organization",
    preamble: location.pathname.split("/page")[0],
    isEditing: false
  };

  for (let i = 0; i < split.length; i++) {
    const element = split[i];
    if (element === "group") {
      output.groupId = split.length > i + 1 ? parseInt(split[i + 1]) : undefined;
      if (output.groupId) {
        output.group = groups?.find((group) => group.id === output.groupId);
      }
      continue;
    }
    if (element === "location") {
      output.locationId = split.length > i + 1 ? parseInt(split[i + 1]) : undefined;
      if (output.locationId) {
        output.location = locations?.find((location) => location.id === output.locationId);
      }
      continue;
    }
    if (element === "page") {
      output.page = split.length > i + 1 ? split[i + 1] : undefined;
      output.subPage = split.length > i + 2 ? split[i + 2] : undefined;
      output.subPage = split.length > i + 2 ? split[i + 2] : undefined;
      output.action = split.length > i + 3 ? split[i + 3] : undefined;
      continue;
    }
  }

  if (output.groupId) {
    if (output.locationId) {
      output.type = LocationScope.LOCATION;
      output.typeTitle = "Location";
    } else {
      output.type = LocationScope.GROUP;
      output.typeTitle = "Group";
    }
  }
  const canEditLocationDetails = HasPermission(APIScope.LOCATION_DETAILS_WRITE, Member!.orgId, output.groupId, output.locationId);
  output.isEditing = canEditLocationDetails && (output.action === "edit" || output.page === "cortex" || output.page === "spot");

  return output;
}
